import { Box, Input, InputProps } from "@chakra-ui/react";
import { MdLocationOn } from "react-icons/md";

import { useGeocoderInput } from "../hooks/geocoder-input-hook";

export function GeocoderInput(rest: InputProps) {
  const {
    geocoderFeatures,
    searchString,
    setSearchString,
    setMaptilerFeature,
    selectedPlace,
    onKeyDown,
  } = useGeocoderInput();

  return (
    <Box m={0} position="relative" h="40px">
      <Input
        autoFocus={true}
        placeholder="Zoek adres..."
        bg="white"
        {...rest}
        value={searchString}
        onChange={(e) => setSearchString(e.target.value)}
        onKeyDown={onKeyDown}
        zIndex="0"
        w="full"
      />
      <Box position="absolute" top="40px" left="0" zIndex="2" bg="white" w="100%" cursor="pointer">
        {geocoderFeatures.map((feature, idx) => {
          const onClick = () => setMaptilerFeature(feature);

          const selected = selectedPlace === idx + 1;

          return (
            <Box
              w="100%"
              key={feature.id}
              p="8px"
              borderColor={selected ? "brand.secondary" : "pipelife_blue.medium"}
              bg={selected ? "brand.primary" : undefined}
              borderWidth="1px"
              onClick={onClick}
              _hover={{ bg: "pipelife_blue.medium" }}
            >
              <MdLocationOn /> {feature.place_name}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
